import { Box, Paper, Typography } from "@mui/material";
import { ReactNode } from "react";

/**
 * Et afsnit på en side: overskrift og indhold i en ramme. Bruges til at dele de lange
 * visninger (breef, deltager) op, så man kan finde rundt i dem.
 */
const Section = ({ title, description, actions, children }: { title: string; description?: string; actions?: ReactNode; children: ReactNode }) => (
  <Paper variant="outlined" sx={{ p: { xs: 2, md: 3 }, mb: 2 }}>
    <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 2, mb: 2, flexWrap: "wrap" }}>
      <Box>
        <Typography variant="h3" component="h2">
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {description}
          </Typography>
        )}
      </Box>
      {actions && <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>{actions}</Box>}
    </Box>
    {children}
  </Paper>
);

export default Section;
